export const levels = ["none", "admin"]; // in the future we can add read/write etc.

export const actions = ["admin"];

export const LOCKED_LEVEL_BY_KEY = {
  dashboard: "admin", // or "admin" if you insist
};

export const levelDefinitions = [
        {
            id: 'none',
            label: 'None',
            description: "No access (can't see or open the page)."
        },
        {
            id: 'admin',
            label: 'Admin',
            description: 'Full control, including configuration and destructive actions.'
        },
    ];

// Presets for permission levels
export const presets = [
  { id: "none", label: "None", description: "No access", actions: [], color: "default" },
  { id: "admin", label: "Admin", description: "Full control", actions: ["view", "edit", "delete", "admin"], color: "success" }
];

// Get preset from actions array
export function getPresetFromActions(actions) {
  if (!actions || actions.length === 0) {
    return presets.find(p => p.id === "none");
  }
  if (actions.includes("admin")) {
    return presets.find(p => p.id === "admin");
  }
  return presets.find(p => p.id === "none");
}

export const categories = [
      {
        id: "core",
        title: "Core & Operations",
        subTitle:'Dashboard, Document Archive, Document Portfolio, Event Viewer',
        resources: [
          { key: "dashboard", label: "Dashboard" },
          { key: "documentArchive", label: "Document Archive" },
          { key: "documentPortfolio", label: "Document Portfolio" },
          { key: "eventViewer", label: "Event Viewer", allowedActions: ["admin"] }
        ],
      },
      {
        id: "documentManagement",
        title: "Document Management",
        subTitle:'Document Type Configuration, File Drop, Poller Service',
        resources: [
          { key: "documentTypeConfiguration", label: "Document Type Configuration" },
          { key: "fileDrop", label: "File Drop" },
          { key: "pollerService", label: "Poller Service" } 
        ],
      },
      {
        id: "outputAndDistribution",
        title: "Output & Distribution",
        subTitle:'Print Server, Print Destinations, Email Template Designer',
        resources: [
          { key: "printServer", label: "Print Server" },
          { key: "PrintDestinations", label: "Print Destinations" },
          { key: "EmailTemplateDesigner", label: "Email Template Designer" } 
        ],
      },
      {
        id: "administrationAndAccessControl",
        title: "Administration & Access Control",
        subTitle:'Administration',
        resources: [
          { key: "administration", label: "Administration" }
        ],
      },
      {
        id: "SystemAndPlatform",
        title: "System & Platform",
        subTitle:'Configuration, License',
        resources: [
          { key: "configuration", label: "Configuration" },
          { key: "license", label: "License" }
        ],
      },
    ];